import { getUID } from '@redviking/argonaut-util/src/getUID';
import type { NodeSpec } from './NodeSpec';
import type { NodeCfg } from '@redviking/argonaut-util/types/mes/applet-designs/flow.latest';
import { defineControlOpts } from '../../controls/FlowNodeControl';
import { defaultControlUpdateValueHandler } from '@redviking/argonaut-core-ui/src/applet/design/flows/controls/control-event-handler';

export const txtFormatNodeSpec: NodeSpec<NodeCfg<'txtFormat'>> = {
    requiredSockets: [ 'output' ],
    cfg: () => ({ controlValues: { formatTemplate: '', inputs: 0 }, id: getUID(), kind: 'txtFormat', disabled: false }),
    controls: nodeCfg => ({
        formatTemplate: defineControlOpts({
            cfg: {
                kind: 'textarea',
                placeholder: 'Format',
            },
            on: { 'update:value': defaultControlUpdateValueHandler },
            index: 0,
            value: nodeCfg.controlValues.formatTemplate,
        }),
        inputs: defineControlOpts({
            cfg: {
                kind: 'button',
                useDialog: null,
                label: 'Add Input',
            },
            on: {
                'update:value': () => {}, // no-op, this control does not use the update:value event
                'click': (_, { flowEventEmitter }) => {
                    flowEventEmitter.emit('updateNodeCfg', {
                        newNodeCfg: {
                            ...nodeCfg,
                            controlValues: {
                                ...nodeCfg.controlValues,
                                inputs: nodeCfg.controlValues.inputs + 1,
                            },
                        },
                    });
                },
            },
            index: 1,
            value: nodeCfg.controlValues.inputs,
        }),
    }),
    inputs: nodeCfg => {
        const inputs: ReturnType<NodeSpec<NodeCfg<'txtFormat'>>['inputs']> = {};
        for (let index = 0; index < nodeCfg.controlValues.inputs; index++) {
            inputs[`input${index}`] = {
                controlOpts: defineControlOpts({
                    cfg: {
                        kind: 'deletableSocket',
                        label: `$${index}`,
                    },
                    value: null,
                    enableWithConnectedSocket: true,
                    on: {
                        'update:value': () => {}, // no-op, this control does not use the update:value event
                        'delete': (_, { flowEventEmitter }) => {
                            flowEventEmitter.emit('removeNodeSocket', {
                                newNodeCfg: {
                                    ...nodeCfg,
                                    controlValues: {
                                        ...nodeCfg.controlValues,
                                        inputs: nodeCfg.controlValues.inputs - 1,
                                    },
                                },
                                direction: 'input',
                                removalMethod: {
                                    index,
                                    prefix: 'input',
                                    kind: 'indexedIdentifier',
                                },
                            });
                        },
                    },
                }),
                socket: 'varValue',
            };
        }
        return inputs;
    },
    kindLabel: 'Text Format',
    nodeCategory: 'text',
    outputs: () => ({ output: { socket: 'string', label: 'Output' } }),
    validator: node => {
        if (!node.controlValues.formatTemplate) {
            return { formatTemplate: 'Format Template is required' };
        }
        return true;
    },
};
